import { JSX } from "react";
import "../../App.css";
import { appContext } from "../../AppContext";
import { IbssPage } from "../../Components/Core/BasePage/IbssPage";
import "./Styles.scss";

class AccessDenied extends IbssPage<IProps, IState>
{
    public componentDidMount(): void
    {
        this.pageTitle = appContext().labels.HubLabelaccessDeniedLabel;
    }

    public render(): JSX.Element
    {
        return (
            <div className="content">
                <div className="card">
                    <h3>{appContext().labels.HubLabelaccessDenied}</h3>
                </div>
            </div>
        );
    }
}

export default AccessDenied;
export interface IProps { }
export interface IState { }
